import axios from '@/utils/axios'

//商品列表
const selGoodsList = (data = {
  brandName: '',//as brandId , Array String split with ","
  goodsTypeId: '', //二级分类，
  firstCategoryId: '', //一级分类，
  word: '', //search word split with " "
  stockType: '', //enum 0(国内有货) 1(澳洲有货)
  orderBy: '',
  isAsc: false,//只在orderBy不为空时有效
  isEnglishWebsite:true
}, config) => axios.post('/api/v1/pc/goods/list', data, config);
const selHotGoodsList = (query, config) => axios.get('', query, config)
//获取商品详情
const getGoodsDetails = (goodsId, query, config) => axios.get(`/api/v1/pc/goods/${goodsId}`, query, config);

//获取商品多规格相关
const getGoodsSpec = (goodsId, query, config) => axios.get(`/api/v1/pc/spec/${goodsId}`, query, config);

/**
 *
 * @param {*} goodsId
 * @param { type: String, classId: String } query
 * @param {*} config
 * @returns
 */
const getBrandByClassify = (query, config) => axios.get(`/api/v1/pc/class/brand`, query, config)

export default {
  selGoodsList,
  getGoodsDetails,
  getGoodsSpec,
  getBrandByClassify
}



// WEBPACK FOOTER //
// ./src/api/modules/goods.js